// source: inv_api_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.API.v1.Audit', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.API.v1.History', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.API.v1.Location', null, global);
goog.exportSymbol('proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.displayName = 'proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.WFMS.InventoryManagement.API.v1.History.repeatedFields_, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.API.v1.History, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.API.v1.History.displayName = 'proto.Olameter.WFMS.InventoryManagement.API.v1.History';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.API.v1.Audit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.displayName = 'proto.Olameter.WFMS.InventoryManagement.API.v1.Audit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.displayName = 'proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.displayName = 'proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.API.v1.Location, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.API.v1.Location.displayName = 'proto.Olameter.WFMS.InventoryManagement.API.v1.Location';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.displayName = 'proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.displayName = 'proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.toObject = function(includeInstance, msg) {
  var f, obj = {
fileName: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
timeStamp: (f = msg.getTimeStamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile;
  return proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeStamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimeStamp();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string file_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_url = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.getFileUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.setFileUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp time_stamp = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.getTimeStamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile} returns this
*/
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.setTimeStamp = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.clearTimeStamp = function() {
  return this.setTimeStamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryFile.prototype.hasTimeStamp = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.API.v1.History.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.toObject = function(includeInstance, msg) {
  var f, obj = {
inventoryName: jspb.Message.getFieldWithDefault(msg, 1, ""),
taskName: jspb.Message.getFieldWithDefault(msg, 2, ""),
userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
activityType: jspb.Message.getFieldWithDefault(msg, 4, ""),
activityDetail: jspb.Message.getFieldWithDefault(msg, 5, ""),
timeStamp: (f = msg.getTimeStamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
auditsList: jspb.Message.toObjectList(msg.getAuditsList(),
    proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.toObject, includeInstance),
timeZone: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.API.v1.History;
  return proto.Olameter.WFMS.InventoryManagement.API.v1.History.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityDetail(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeStamp(value);
      break;
    case 7:
      var value = new proto.Olameter.WFMS.InventoryManagement.API.v1.Audit;
      reader.readMessage(value,proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.deserializeBinaryFromReader);
      msg.addAudits(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.API.v1.History.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActivityType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActivityDetail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTimeStamp();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAuditsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.serializeBinaryToWriter
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string inventory_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.getInventoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.setInventoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.getTaskName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.setTaskName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string activity_type = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.getActivityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.setActivityType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string activity_detail = 5;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.getActivityDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.setActivityDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp time_stamp = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.getTimeStamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
*/
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.setTimeStamp = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.clearTimeStamp = function() {
  return this.setTimeStamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.hasTimeStamp = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated Audit audits = 7;
 * @return {!Array<!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit>}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.getAuditsList = function() {
  return /** @type{!Array<!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Olameter.WFMS.InventoryManagement.API.v1.Audit, 7));
};


/**
 * @param {!Array<!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit>} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
*/
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.setAuditsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.addAudits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.Olameter.WFMS.InventoryManagement.API.v1.Audit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.clearAuditsList = function() {
  return this.setAuditsList([]);
};


/**
 * optional string time_zone = 8;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.History} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.History.prototype.setTimeZone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.toObject = function(includeInstance, msg) {
  var f, obj = {
historyName: jspb.Message.getFieldWithDefault(msg, 1, ""),
fieldName: jspb.Message.getFieldWithDefault(msg, 2, ""),
oldValue: jspb.Message.getFieldWithDefault(msg, 3, ""),
newValue: jspb.Message.getFieldWithDefault(msg, 4, ""),
timeStamp: (f = msg.getTimeStamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.API.v1.Audit;
  return proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHistoryName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOldValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewValue(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeStamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHistoryName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFieldName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOldValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNewValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimeStamp();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string history_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.getHistoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.setHistoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string field_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.getFieldName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.setFieldName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string old_value = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.getOldValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.setOldValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string new_value = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.getNewValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.setNewValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp time_stamp = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.getTimeStamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} returns this
*/
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.setTimeStamp = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Audit} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.clearTimeStamp = function() {
  return this.setTimeStamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Audit.prototype.hasTimeStamp = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.toObject = function(includeInstance, msg) {
  var f, obj = {
taskName: jspb.Message.getFieldWithDefault(msg, 1, ""),
skipCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
inventoryStatus: jspb.Message.getFieldWithDefault(msg, 3, ""),
comment: jspb.Message.getFieldWithDefault(msg, 4, ""),
taskToCreate: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin;
  return proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSkipCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskToCreate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSkipCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInventoryStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTaskToCreate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string task_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.getTaskName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.setTaskName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string skip_code = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.getSkipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.setSkipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string inventory_status = 3;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.getInventoryStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.setInventoryStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string comment = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string task_to_create = 5;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.getTaskToCreate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryAdmin.prototype.setTaskToCreate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleName: jspb.Message.getFieldWithDefault(msg, 1, ""),
displayName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle;
  return proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string vehicle_name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.prototype.getVehicleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.prototype.setVehicleName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Vehicle.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.API.v1.Location.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
locationName: jspb.Message.getFieldWithDefault(msg, 2, ""),
isVehicle: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
contractName: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.API.v1.Location;
  return proto.Olameter.WFMS.InventoryManagement.API.v1.Location.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVehicle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.API.v1.Location.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocationName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsVehicle();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.getLocationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.setLocationName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_vehicle = 3;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.getIsVehicle = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.setIsVehicle = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string contract_name = 4;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.Location} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.Location.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.toObject = function(includeInstance, msg) {
  var f, obj = {
inventoryId: jspb.Message.getFieldWithDefault(msg, 1, ""),
isPresent: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare;
  return proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInventoryId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPresent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInventoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsPresent();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string inventory_id = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.prototype.getInventoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.prototype.setInventoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_present = 2;
 * @return {boolean}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.prototype.getIsPresent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.InventoryCompare.prototype.setIsPresent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
contractName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker;
  return proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string contract_name = 2;
 * @return {string}
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.prototype.getContractName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker} returns this
 */
proto.Olameter.WFMS.InventoryManagement.API.v1.ContractPicker.prototype.setContractName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.Olameter.WFMS.InventoryManagement.API.v1);
